import {computed} from 'vue';
import {useCurrentHost} from '#imports';
import {useFeatureFlag} from '@malt/feature-flags';

export function useGlobalMatching() {
    const {getCurrentHost} = useCurrentHost();

    const isGlobalMatchingForLocalizedClients = useFeatureFlag('keyword-search-global-matching-for-localized-clients');
    const isGlobalMatchingForDefinedLocalizedCountries = useFeatureFlag('keyword-search-global-matching-for-defined-localized-countries');

    const isBrowsingGlobalMatching = computed(
        () => isGlobalMatchingForLocalizedClients.value || isGlobalMatchingForDefinedLocalizedCountries.value || isMaltDotCom.value,
    );

    const isMaltDotCom = computed(
        () => getCurrentHost() === 'dev.malt.com' || getCurrentHost() === 'www.integration.malt.com' || getCurrentHost() === 'www.malt.com',
    );

    return {
        isBrowsingGlobalMatching,
        isMaltDotCom,
    };
}
